import React from 'react';
import OnboardingPage, { OnboardingPageProps } from '../../../components/OnboardingPage';

const OnboardingIntroScreen = (props: OnboardingPageProps) => <OnboardingPage {...props} />;

export default OnboardingIntroScreen;
